import ConnectedDataPanel from './ConnectedDataPanel';

export default ConnectedDataPanel;
